<!--
 * @Author: lan.h
 * @Date: 2022-02-18 16:24:17
 * @LastEditors: lan.h
 * @LastEditTime: 2022-03-24 14:46:51
 * @Description: 找公司 查看更多
-->
<template>
  <div class="main-index">
    <div class="main">
      <!-- 筛选条件 -->
      <div class="filter">
        <Dropdown @on-click="haddleDropdown($event)" @on-visible-change="changeStatus($event, 'type')">
          <a href="javascript:void(0)">
            {{params.categoryId | dealNeed(type_list)}}
            <i class="iconfont" v-if="type_status">&#xe73c;</i>
            <i class="iconfont" v-else>&#xe73d;</i>
          </a>
          <DropdownMenu slot="list">
            <DropdownItem v-for="item in type_list" :name="item.id" :key="item.id" :selected="params.categoryId == item.id">{{item.name}}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <div class="right">
          <Dropdown class="time" @on-click="dropTopicClick" @on-visible-change="changeStatus($event, 'time')">
            <a href="javascript:void(0)">
              {{drop_topic_text}}
              <i class="iconfont" v-if="time_status">&#xe73c;</i>
              <i class="iconfont" v-else>&#xe73d;</i>
            </a>
            <DropdownMenu slot="list">
              <DropdownItem name="最近7天">最近7天</DropdownItem>
              <DropdownItem name="最近30天">最近30天</DropdownItem>
              <DropdownItem name="最近1年">最近1年</DropdownItem>
              <DropdownItem name="自定义">自定义</DropdownItem>
            </DropdownMenu>
          </Dropdown>
          <p></p>
          <DatePicker
            ref="topic_date_picker"
            @on-change="timeTopicChange"
            type="daterange"
            v-model="date_topic_arr"
            :start-date="new Date()"
            placement="bottom-end"
            :disabled="drop_topic_text != '自定义'"
            :class="{'disabled-date-picker': drop_topic_text != '自定义'}"
            placeholder="开始时间 - 结束时间"
          ></DatePicker>
        </div>
      </div>
      <!-- 信息流 -->
      <ul class="special">
        <Spin fix v-show="loading">
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>
        <li v-for="item, index in articleList" v-cloak :key="index">
          <div class="card" v-if="item.type == 0 || item.type == 1">
            <Article :item="item" :mediaTag="media_tag" :entityNtag="entity_ntag" :category="article_category" :isCollect="true"></Article>
          </div>
          <div class="card" v-if="item.type == 3">
            <ThemePro :item="item" :entityNtag="entity_ntag"></ThemePro>
          </div>
          <div class="card" v-if="item.type == 4" >
            <Topic :item="item" :entityNtag="entity_ntag"></Topic>
          </div>
        </li>
      </ul>
      <div class="more_div" v-if="!(articleList.length == 0 && !more_loading)"><Button  @click="more()" :loading="more_loading" :class="more_loading ? 'more_loading' : ''">{{more_loading ? '加载中' : '加载更多'}}</Button></div>
      <Nothing v-if="params.page == 1 && articleList.length == 0 && !more_loading">
        <p>没有相关动态</p>
      </Nothing>
    </div>
  </div>
</template>

<script>
import ThemePro from '../Main/components/ThemePro'
import Article from '../Main/components/Article'
import Topic from '../Main/components/Topic'
import Nothing from '@/components/Nothing2.vue'
import {  getMeta, companyDynamic } from '../../service'
export default {
  data() {
    return {
      article_category: [], //文章类型
      entity_ntag: [], //赛道标签元数据
      media_tag: [], //文章标签
      loading: false,
      more_loading: false,
      params: {
        userKey: this.$store.state.user_key,
        page: 1,
        categoryId: 2,
        size: 20,
        beginTime: '',
        endTime: '',
      },
      type_list: [
        {id: 2, name: '早期项目发掘机'},
        {id: 3, name: '未来头条公司'},
        {id: 4, name: '活跃机构领域版图'},
        {id: 5, name: '科技巨头投资版图'},
      ],
      type_status: '',
      time_status: '',
      articleList: [],
      drop_topic_text:  '最近1年',
      date_topic_arr: [moment().subtract(365, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
    }
  },
  created() {
    if('categoryId' in this.$route.query){
      this.params.categoryId = Number(this.$route.query.categoryId)
    }
    this.getMeta()
    this.getList()
  },
  methods: {
    /**
     * @description: 栏目元数据
     * @param {*}
     * @return {*}
     */    
    async getMeta() {
      let res = await getMeta({
        name: ['article_category', 'entity_ntag', 'media_tag']
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'article_category', res.meta.article_category)
        this.$set(this.$data, 'entity_ntag', res.meta.entity_ntag)
        this.$set(this.$data, 'media_tag', res.meta.media_tag)
      } else {
        this.$Message.error(res.msg)
      }
    },
    /**
     * @description: 信息流
     * @param {*}
     * @return {*}
     */    
    async getList() {
      this.more_loading = true
      this.params.beginTime =  moment(this.date_topic_arr[0]).format('YYYY-MM-DD')
      this.params.endTime =  moment(this.date_topic_arr[1]).format('YYYY-MM-DD')
      let res = await companyDynamic( this.params, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.code == 0) {         
        if(res.data.length == 0){
          this.$Message.warning('暂无更多数据！')
        }
        this.articleList = this.articleList.concat(res.data)
        this.more_loading = false
      } else {
        this.$Message.error(res.msg)
      }
    },
    dropTopicClick(name) { // drop的点击事件
      this.drop_topic_text = name
      if (name == '最近7天') {
        this.date_topic_arr = [moment().subtract(7, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
        this.articleList = []
        this.params.page = 1
        this.getList()
      } else if(name == '最近30天'){
        this.date_topic_arr = [moment().subtract(30, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
        this.articleList = []
        this.params.page = 1
        this.getList()
      } else if(name == '最近1年'){
        this.date_topic_arr = [moment().subtract(365, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
        this.articleList = []
        this.params.page = 1
        this.getList()
      } else{
        this.date_topic_arr = []
      }
    },
    timeTopicChange() {
      this.articleList = []
      this.params.page = 1
      this.getList()
    },
    haddleDropdown(id) {
      this.articleList = []
      this.params.categoryId = id
      this.params.page = 1
      this.getList()
    },
    changeStatus(status, type) {
      this[type + '_status'] = status
    },
    /**
     * @description: 加载更多
     * @param {*}
     * @return {*}
     */    
    more() {
      this.params.page = this.params.page+1
      this.getList()
    }
  },
  components: {
    ThemePro,
    Article,
    Topic,
    Nothing
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common_vcbeat.stylus'
.main-index
  background #fff
  display flex
  justify-content center
  min-height calc(100vh - 65px)
.main
  width 1100px 
  margin 20px 0 36px 0
  
  background #fcfcfc
  padding 20px 50px
  .filter
    display flex 
    justify-content space-between
    align-items center
    border-bottom 1px solid #E9E9E9
    padding-bottom 15px
    .right 
      display flex 
      align-items center
      p 
        width 1px 
        height 20px 
        background-color #E9E9E9
        margin 0 10px
    >>>.ivu-dropdown
      .ivu-dropdown-rel
        a 
          font-size 14px
          font-weight bold
          color #333333
          line-height 1
          padding 6px 8px
          i 
            font-size 14px
            color #FA5A00
            margin-left 8px
    >>>.ivu-date-picker
      input
        height: 30px;
        border: 0
        padding: 0
        // width: fit-content
        width 186px
        text-align center
        font-size 14px
        background-color #fcfcfc
        &[disabled]
          background-color #fcfcfc
          color #333
      .ivu-input-suffix,.ivu-input-icon
        display none
      &.ivu-date-picker-focused
        outline: 0
        input
          border-color #dcdee2
          box-shadow none !important
      .ivu-input:focus
        box-shadow none
  .special
    margin-top 14px
    .loading_bg
      height 470px
      width 100%
      position relative
    li 
      >div
        padding 15px 0
        position relative
        transition all .2s
      .card
        width 100% 
      >>>.spc_img 
        .icon_column 
          font-size 12px
          line-height 24px
          position absolute
          z-index 1
          top 10px
          left 10px
          height 24px
          padding 0 6px
          color #fff
          background #FA5A00
          font-weight 500
          
          display inline-block
  .more_div 
    text-align center
    padding-top 40px
    padding-bottom 40px
    button 
      color #FA5A00
      border 1px solid #FA5A00
      width 126px
      height 38px
      background #fcfcfc
      cursor pointer
      border-radius 20px
      &:focus
        box-shadow none
    .more_loading
      border-color #fcfcfc
    .ivu-btn:before
      background #fcfcfc
  >>>.nothing
    background transparent
</style>